export default __webpack_public_path__ + "static/media/resourceelumnt2.140606e3.jpg";